module.exports = __webpack_public_path__ + "static/media/panco_tablet.d50af405.jpg";